export function isRolePermissionEditable(role) {
  return role !== 'DEVELOPER';
}
